import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { loadPreference, savePreference, UserPreferenceCodes } from "requests/preferences";

export const AssignmentPinsContext = React.createContext(null);

export interface PinsPreference {
  code: string;
  name: string;
}

export const pinCodes = {
  default: "default",
  icons: "icons"
};

export const PinsPreferences: PinsPreference[] = [
  { code: pinCodes.default, name: "Default" },
  { code: pinCodes.icons, name: "Icons" },
];

const defaultPinsPreference = PinsPreferences.find(p => p.code === pinCodes.default);

export interface AssignentPinsProvderValue {
  change: (newCode: string) => void;
  current: PinsPreference;
  options: PinsPreference[];
};

const AssignmentPinsProvider = ({ children, internetUserId }) => {
  const [currentPreference, setCurrentPreference] = useState(defaultPinsPreference);
  const mounted = useRef(true);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (internetUserId) {
      loadPreference(UserPreferenceCodes.assignmentToolPins, preference => {
        if (preference.value) changePreference(preference.value);
      }, mounted);
    }
  }, [internetUserId]);

  const changePreference = (newCode: string) => {
    const newPreference = Object.values(PinsPreferences).find(p => p.code === newCode) || defaultPinsPreference;
    setCurrentPreference(newPreference)
    savePreference(UserPreferenceCodes.assignmentToolPins, newCode, null, mounted);
  };

  const providerValue = {
    change: changePreference,
    current: currentPreference,
    options: PinsPreferences,
  };

  return <AssignmentPinsContext.Provider value={providerValue}>{children}</AssignmentPinsContext.Provider>;
};

const mapStateToProps = state => ({
  internetUserId: state.user.profile.internetUserId,
});

export default connect(mapStateToProps)(AssignmentPinsProvider);